import { useState, useEffect } from 'react';
import { Producto } from '../../types';
import { api } from '../../api/client';
import ProductoForm from './ProductoForm';
import { sanitizeHtml } from '../../utils/sanitize';


export default function ProductoList() {
  const [productos, setProductos] = useState<Producto[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingProducto, setEditingProducto] = useState<Producto | null>(null);

  useEffect(() => {
    loadProductos();
  }, []);

  const loadProductos = async () => {
    const data = await api.productos.list();
    setProductos(data);
    setLoading(false);
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm('¿Eliminar este producto?')) return;
    await api.productos.delete(id);
    loadProductos();
  };

  const handleEdit = (p: Producto) => {
    setEditingProducto(p);
    setShowForm(true);
  };

  const handleFormSubmit = () => {
    setShowForm(false);
    setEditingProducto(null);
    loadProductos();
  };

  if (loading) return <p>Cargando productos...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Productos</h1>
        <button
          onClick={() => setShowForm(true)}
          className="bg-green-600 text-white px-4 py-2 rounded"
        >
          + Nuevo Producto
        </button>
      </div>

      {showForm && (
        <ProductoForm
          initialData={editingProducto || undefined}
          onSubmit={handleFormSubmit}
          onCancel={() => {
            setShowForm(false);
            setEditingProducto(null);
          }}
          isEdit={!!editingProducto}
          id={editingProducto?.id}
        />
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {productos.map((p) => (
          <div key={p.id} className="border rounded p-4 bg-white shadow">
            <h3 className="font-bold text-lg">{p.nombre}</h3>
            <p className="text-gray-600" dangerouslySetInnerHTML={{ __html: sanitizeHtml(p.descripcion ?? '') }}></p>
            <p><strong>Precio:</strong> S/{p.precio.toFixed(2)}</p>
            <p><strong>Stock:</strong> {p.stock}</p>
            {p.url_imagen && p.url_imagen.startsWith('http') && (
              <img src={p.url_imagen} alt={p.nombre} className="mt-2 w-16 h-16 object-cover rounded" />
            )}
            <div className="mt-3 space-x-2">
              <button
                onClick={() => handleEdit(p)}
                className="text-blue-600 hover:underline text-sm"
              >
                Editar
              </button>
              <button
                onClick={() => handleDelete(p.id)}
                className="text-red-600 hover:underline text-sm"
              >
                Eliminar
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}